import { api } from '@/lib/api';

export const studioApi = '/sharingan';
export const errorText = (error) => typeof error?.response?.data?.detail === 'string' ? error.response.data.detail : 'Une erreur est survenue. Réessayez.';
export const canEdit = (user) => ['super_admin', 'manager', 'collaborator'].includes(user?.role);
export const isBusy = (p) => ['queued', 'running'].includes(p?.status);
export const statusLabel = { queued: 'En attente', running: 'Capture en cours', done: 'Prêt', failed: 'Échec', cancelled: 'Annulé' };
export const phaseLabel = { detect: 'Analyse de la cible', mirror: 'Miroir 1:1', catalog: 'Catalogue produits', theme: 'Thème Shopify', backup: 'Sauvegarde' };
export const platformLabel = { shopify: 'Shopify', woocommerce: 'WooCommerce', wordpress: 'WordPress', prestashop: 'PrestaShop', wix: 'Wix', squarespace: 'Squarespace', webflow: 'Webflow', bigcommerce: 'BigCommerce', magento: 'Magento', wizishop: 'WiziShop', other: 'Site personnalisé' };
export const dateLabel = (value) => value ? new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).format(new Date(value)) : '';
export const bytesLabel = (n = 0) => n > 1e9 ? `${(n / 1e9).toFixed(2)} Go` : n > 1e6 ? `${(n / 1e6).toFixed(1)} Mo` : `${Math.round(n / 1000)} Ko`;

export async function downloadBlob(request, fallbackName) {
  try {
    const response = await request();
    const name = response.headers['content-disposition']?.match(/filename="([^"]+)"/)?.[1] || fallbackName;
    const url = URL.createObjectURL(response.data);
    const link = document.createElement('a'); link.href = url; link.download = name; link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1500);
  } catch (error) {
    if (error.response?.data instanceof Blob) { try { error.response.data = JSON.parse(await error.response.data.text()); } catch { /* generic */ } }
    throw error;
  }
}

export const downloadZip = (pid, kind, name) => downloadBlob(() => api.get(`${studioApi}/${pid}/download/${kind}`, { responseType: 'blob', timeout: 300000 }), `${name}-${kind}.zip`);
export const downloadCSV = (pid, ids, name) => downloadBlob(() => api.post(`${studioApi}/${pid}/products/export`, { ids }, { responseType: 'blob', timeout: 300000 }), `${name}-shopify-products.csv`);
